var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Chart as ChartJS, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { FactoryInstance } from '../../../factory';
import { Chart } from './Chart';
import { ChartLegendElement } from './Chart.LegendElement';
export * from './Chart';
ChartJS.register.apply(ChartJS, __spreadArray(__spreadArray([], registerables, false), [ChartDataLabels], false));
FactoryInstance.registerComponent(Chart);
FactoryInstance.registerComponent(ChartLegendElement);
